// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host::ng-deep ol {
  padding-left: 18px;
}
:host::ng-deep ol > li h3 {
  font-family: AppFontBold;
}
:host::ng-deep ol > li p {
  font-family: AppFont;
  margin: 0;
  margin-bottom: 5px;
}
:host::ng-deep ol > li ol > li {
  margin: 8px 0;
}
:host::ng-deep ion-content > ol {
  padding: 0;
}
:host::ng-deep ion-content > ol > li:before {
  content: none;
}
:host::ng-deep ul {
  list-style-type: disc;
  padding-left: 30px;
}
:host::ng-deep ion-content > ol > li > div {
  padding-left: 30px;
}
:host::ng-deep p.ion-padding-start {
  padding-left: 30px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/tos/tos.page.scss"],"names":[],"mappings":"AAEE;EACC,kBAAA;AADH;AAKG;EACC,wBAAA;AAHJ;AAYG;EACC,oBAAA;EACA,SAAA;EACA,kBAAA;AAVJ;AAaG;EACC,aAAA;AAXJ;AAqBE;EACC,UAAA;AAnBH;AAsBE;EACC,aAAA;AApBH;AAuBE;EACC,qBAAA;EACA,kBAAA;AArBH;AAwBE;EACC,kBAAA;AAtBH;AAyBE;EACC,kBAAA;AAvBH","sourcesContent":[":host {\n\t&::ng-deep {\n\t\tol {\n\t\t\tpadding-left: 18px;\n\t\t}\n\n\t\tol > li {\n\t\t\th3 {\n\t\t\t\tfont-family: AppFontBold;\n\t\t\t}\n\n\t\t\t// h3:before {\n\t\t\t// \tcontent: counters(item, '.') '. ';\n\t\t\t// \tcounter-increment: item;\n\t\t\t// \tmargin-right: 6px;\n\t\t\t// }\n\n\t\t\tp {\n\t\t\t\tfont-family: AppFont;\n\t\t\t\tmargin: 0;\n\t\t\t\tmargin-bottom: 5px;\n\t\t\t}\n\n\t\t\tol > li {\n\t\t\t\tmargin: 8px 0;\n\t\t\t}\n\t\t}\n\n\t\t// ol > li:before {\n\t\t// \tcontent: counters(item, '.') ' ';\n\t\t// \tcounter-increment: item;\n\t\t// \tmargin: 0 8px 0 0;\n\t\t// }\n\n\t\tion-content > ol {\n\t\t\tpadding: 0;\n\t\t}\n\n\t\tion-content > ol > li:before {\n\t\t\tcontent: none;\n\t\t}\n\n\t\tul {\n\t\t\tlist-style-type: disc;\n\t\t\tpadding-left: 30px;\n\t\t}\n\n\t\tion-content > ol > li > div {\n\t\t\tpadding-left: 30px;\n\t\t}\n\n\t\tp.ion-padding-start {\n\t\t\tpadding-left: 30px;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
